import { render, staticRenderFns } from "./tareasprogramadas-form.vue?vue&type=template&id=4b002034&scoped=true"
import script from "./tareasprogramadas-form.vue?vue&type=script&lang=js"
export * from "./tareasprogramadas-form.vue?vue&type=script&lang=js"
import style0 from "./tareasprogramadas-form.vue?vue&type=style&index=0&id=4b002034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b002034",
  null
  
)

export default component.exports